<template>
  <div>
    <v-layout row wrap justify-space-between>
      <!-- Search & add vehicles (left) -->
      <v-flex xs12 md6>
        <h3 class="subtitle-1 mb-2">
          {{ labelSearch }}
        </h3>

        <v-layout row wrap>
          <v-flex xs12 sm7>
            <v-text-field
              v-model="searchKeywords"
              append-icon="fal fa-search"
              label="Search by license plate or shortcode"
              :loading="apiInProgress"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs12 sm4 class="ml-3" v-if="hasAgencyDropdown">
            <st-select
              v-model="selectedAgencyId"
              :items="agencyOptions"
              label="Agency"
              item-text="text"
              item-value="value"
              :disabled="disabled"
              clearable
            />
          </v-flex>
        </v-layout>

        <div style="overflow-y: auto; height: 250px">
          <v-list dense>
            <template v-for="vehicle in searchResults">
              <v-list-tile
                :disabled="disabled || isProfileSelected(vehicle.id)"
                @click.stop="addProfile(vehicle)"
                :key="vehicle.id"
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    ({{ vehicle.shortcodeId }}) {{ vehicle.licensePlateNumber }}
                  </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-icon small>fas fa-chevron-right</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
        </div>

        <div class="mt-2 d-flex align-center justify-space-between">
          <div>
            <span v-if="totalCount">
              Showing {{ fromItem }}–{{ toItem }} of {{ totalCount }}
            </span>
            <span v-else>
              No results
            </span>
          </div>
          <div>
            <v-btn
              small
              fab
              :disabled="disabled || currentPage <= 1 || !totalCount"
              @click="goToPreviousPage"
            >
              <v-icon small>fas fa-chevron-left</v-icon>
            </v-btn>
            <v-btn
              small
              fab
              :disabled="disabled || currentPage >= totalPages || !totalCount"
              @click="goToNextPage"
            >
              <v-icon small>fas fa-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>
      </v-flex>

      <!-- Selected vehicles (right) -->
      <v-flex xs12 md5>
        <h3 class="subtitle-1 mb-2">
          {{ labelSelected }}
        </h3>

        <div style="overflow-y: auto; height: 350px" v-if="selectedProfiles && selectedProfiles.length">
          <v-list dense>
            <v-list-tile
              v-for="profile in selectedProfiles"
              :key="profile.id"
            >
              <v-list-tile-content>
                <v-list-tile-title :title="`(${profile.shortcodeId}) ${profile.licensePlateNumber}`">
                  ({{ profile.shortcodeId }}) {{ profile.licensePlateNumber }}
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn
                  icon
                  small
                  :disabled="disabled"
                  @click.stop="removeProfile(profile.id)"
                  title="Remove vehicle"
                >
                  <v-icon small>fas fa-trash-alt</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </div>
        <div v-else>
          <p>No vehicles selected yet.</p>
        </div>
      </v-flex>
    </v-layout>

    <v-layout row justify-end class="mt-3">
      <v-btn
        color="warning"
        flat
        @click="onCancel"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :disabled="disabled"
        @click="onSubmit"
      >
        Done
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import src from './src'
export default src
</script>
